import { emit, events } from '@estee/elc-service-bus';

export class SignInLinkUseCase {
    public execute = () => {
        emit(events.SIGN_IN_LINK_CLICKED);
    };
}
